import React from "react";

// The app's on/off switch. By default it is the Material style used on the
// app's settings screens (purple knob on a lavender track). The device detail
// page passes knobColor and trackColor to match the device's colours, as the
// app's react-native-switch does.
const AppSwitch = ({ checked, onChange, disabled = false, label, knobColor, trackColor, className = "", tabIndex }) => (
  <button
    type="button"
    role="switch"
    aria-checked={Boolean(checked)}
    aria-label={label}
    disabled={disabled}
    tabIndex={tabIndex}
    className={`hx-switch ${checked ? "is-on" : ""} ${className}`}
    style={{
      ...(knobColor ? { "--hx-switch-knob-on": knobColor } : null),
      ...(trackColor ? { "--hx-switch-track-on": trackColor } : null),
    }}
    onClick={() => onChange?.(!checked)}
  >
    <span className="hx-switch-knob" />
  </button>
);

export default AppSwitch;
